export default __webpack_public_path__ + "static/media/img18.8a222326.svg";